import React from 'react'
import { Blue_Border } from '../constants'
import { Box, Grid2 } from '@mui/material'

const LingtBlueContainer = ({ children, direction, sx }) => {
    return (
        <Box sx={{ border: Blue_Border, px: 2, py: 2, borderRadius: "15px", bgcolor: "blue.lighter", display: "flex", flexDirection: direction || "column", alignItems: "center", ...sx }}>
            {children}

        </Box>
    )
}

export default LingtBlueContainer

export const DarkBlueContainer = ({ children, bgcolor }) => {
    return (
        <Box
            sx={{
                backgroundColor: bgcolor || "#C7D5FF",
                display: "inline-flex",
                borderRadius: "5px",
                p: 0.5,
                gap: 1

            }}
        >
            {children}
        </Box>
    )
}

export const GridChildren = ({ children, index, sx }) => {
    return (
        <Grid2
            key={index}
            size={{ lg: 6, sm: 6, xs: 12 }}
            display="flex"
            alignItems="stretch"
            sx={{ ...sx }}
        >
            {children}
        </Grid2>
    )
}